import request from '@/utils/request'

/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
/**
 * @description 获取 OSS 直传签名
 * @param {String} dir 本次上传要写入的目录，需以 / 结尾且命中后端白名单
 *                     （如 upload/2026-10-26/ 或 2026/10/26/），用于限制直传 key 前缀
 */
export function getOssConfig (dir) {
  return request({
    url: '/common/get-oss-signature',
    method: 'get',
    params: { dir }
  })
}